export default __webpack_public_path__ + "static/media/facebookIcon.0c52ddb2.svg";